import Vue from "vue";

Vue.filter("decimalCurrency", (value, returnNumber, returnWithMark) => {
    if (typeof value !== "number") {
        return value;
    }

    // Format the number to always have 2 decimal places
    const formattedNumber = value.toFixed(2); // Ensures always 2 decimal places
    const formattedStringWithComma = formattedNumber.replace(".", ",");

    if (returnNumber) {
        const formatterNumber = parseFloat(formattedNumber);

        if (!returnWithMark) {
            return formatterNumber;
        } else {
            return `${formatterNumber.toFixed(2)} €`; // Ensure 2 decimals even when returning number
        }
    }

    return formattedStringWithComma + " €";
});
